<mat-stepper #stepper [linear]="true" class="register">
    <mat-step *ngIf="community?.questions?.length">
        <ng-template matStepLabel>
            <div [innerHTML]=" community?.eligibility_survey_title_rendered || 'Eligibility'"></div>
        </ng-template>

        <app-onboarding-questions #appOnboardingQuestionsComponent (onSuccessEligibilityCheck)="checkEligibility()"
                                  (storeEligibilityAnswers)="setAnswers($event)"
                                  [community]="community"
                                  [showHeader]="false"/>
    </mat-step>
    <mat-step *ngIf="community?.profile_questions_count && community?.profile_questions_count > 0">
        <ng-template matStepLabel>
            <div [innerHTML]="community?.profile_survey_title_rendered  || 'Profile'"></div>
        </ng-template>

        <app-profile-questions [card]="false" #appProfileQuestionsComponent
                               (storeProfileAnswers)="setProfileAnswers($event)"
                               [isRegistrationPage]="true"
                               [redirect]="false"
                               [community]="community"
                               [showHeader]="false"/>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>
            <div [innerHTML]="community?.registration_form_title_rendered || 'Register'"></div>
        </ng-template>
        <ng-container *ngIf="!login">
            <!--      <p>If you already have an explain account please login to complete your registration
                      <button mat-raised-button color="accent" (click)="login = true">Login</button>
                  </p>-->

            <p *ngIf="!this.community?.register_intro_text_rendered">
                Welcome to the {{ companyName }} online community, please create an account to get involved.
                This information will be stored by Explain Market Research, the organisation who help us manage this
                community. You can read more about how we use your data in our
                <a [routerLink]="['/privacy-policy']" target="_blank">Privacy Policy</a>.
            </p>


            <div *ngIf="this.community?.register_intro_text_rendered"
                 [innerHTML]="community?.register_intro_text_rendered"
                 class="ck-editorControl"></div>
            <form [formGroup]="signUpForm" class="mt-10">
                <div [class.rowTwo]="!this.community?.hide_post_code">
                    <div [class.column-reverse]="this.community?.register_username_help_text_below_input">
                        <div [innerHTML]="community?.username_help_text_rendered? community?.username_help_text_rendered: '<p>Create a username to create your community profile, but don\'t use your real name or email address as this will be visible to community members. Your username can only contain alphanumeric characters, including (-_8.) and no spaces.</p>'"
                             class="muted ck-editorControl">
                        </div>
                        <mat-form-field appearance="outline" class="w-100" color="accent">
                            <mat-label>Username</mat-label>
                            <input formControlName="username" matInput>
                            <mat-error *ngIf="signUpForm.controls['username'].hasError('required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="signUpForm.controls['username'].hasError('pattern')">
                                Your username can only contain alphanumeric characters, including (-_8.) and no spaces.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div [class.column-reverse]="this.community?.register_post_code_help_text_below_input">
                        <ng-container *ngIf="!this.community?.hide_post_code">
                            <div [innerHTML]="community?.post_code_help_text_rendered? community?.post_code_help_text_rendered: '<p>We use this information to understand the geographic spread of our members, this will not be visible to community members</p>'"
                                 class="muted ck-editorControl">
                            </div>
                            <mat-form-field appearance="outline" class="w-100" color="accent">
                                <mat-label>{{ community?.postcode_placeholder_text ? community.postcode_placeholder_text : 'Your postcode e.g. NE1' }}</mat-label>
                                <input formControlName="postcode" matInput maxlength="4" minlength="2">
                                <mat-error *ngIf="signUpForm.controls['postcode'].hasError('required')">
                                    This field is required
                                </mat-error>
                                <mat-error
                                        *ngIf="signUpForm.controls['postcode'].hasError('pattern') && !signUpForm.controls['postcode'].hasError('minlength') && !signUpForm.controls['postcode'].hasError('maxlength')">
                                    Please enter a valid first half of a postcode
                                </mat-error>
                                <mat-error *ngIf="signUpForm.controls['postcode'].hasError('maxlength')">
                                    First half of a postcode should be no more than 4 characters
                                </mat-error>
                                <mat-error *ngIf="signUpForm.controls['postcode'].hasError('minlength')">
                                    First half of a postcode should be no less than 2 characters
                                </mat-error>

                            </mat-form-field>
                        </ng-container>
                    </div>
                </div>
                <div [class.column]="community?.stacked_confirmation_dialogs" class="rowTwo">
                    <div [class.column-reverse]="this.community?.register_email_help_text_below_input">
                        <div [innerHTML]="community?.email_help_text_rendered? community?.email_help_text_rendered: '<p>We need your email address to create your account and so that the community manager can send you transactional emails, this will not be visible to community members. These emails will contain information relevant to the community. such as updates and reminders on new community content, member interactions and prize draw announcements</p>'"
                             class="muted ck-editorControl">
                        </div>
                        <mat-form-field [class.disabled]="invite" appearance="outline" class="w-100" color="accent">
                            <mat-label>Email address</mat-label>
                            <input #email [attr.disabled]="invite" [readonly]="invite" class="form-control"
                                   formControlName="email"
                                   matInput type="email"/>
                            <mat-error *ngIf="signUpForm.controls['email'].hasError('required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="signUpForm.controls['email'].hasError('email')">
                                Please enter a valid email address
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="justify-content-end">
                        <mat-form-field [class.disabled]="invite" appearance="outline" class="w-100" color="accent">
                            <mat-label>Confirm email address</mat-label>
                            <input #confirmEmail [attr.disabled]="invite" [readonly]="invite" class="form-control"
                                   formControlName="confirmEmail" matInput
                                   type="email"/>
                            <mat-error *ngIf="signUpForm.controls['confirmEmail'].hasError('required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="signUpForm.controls['confirmEmail'].hasError('email')">
                                Please enter a valid email address
                            </mat-error>
                            <mat-hint
                                    *ngIf="signUpForm.get('confirmEmail')?.dirty && email.value !== confirmEmail.value"
                                    class="errorMsg">
                                Email does not match
                            </mat-hint>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="community?.password_help_text_rendered && !this.community?.register_password_help_text_below_input"
                     [innerHTML]="community?.password_help_text_rendered"
                     class="muted ck-editorControl">
                </div>
                <div [class.column]="community?.stacked_confirmation_dialogs" class="rowTwo">
                    <div>
                        <mat-form-field appearance="outline" class="w-100" color="primary">
                            <mat-label>Password</mat-label>
                            <input #password formControlName="password" matInput maxlength="32" minlength="8"
                                   type="password">
                            <mat-error (click)="password.focus()"
                                       *ngIf="signUpForm.controls['password'].hasError('required')">
                                This field is required
                            </mat-error>
                            <mat-error (click)="password.focus()"
                                       *ngIf="signUpForm.controls['password'].hasError('minlength')"
                                       [style.color]="community?.password_minimum_character_alert_colour_hex">
                                Password must be at least 8 characters long
                            </mat-error>
                            <mat-error (click)="password.focus()"
                                       *ngIf="signUpForm.controls['password'].hasError('maxlength')">
                                Password must be at less than 32 characters long
                            </mat-error>
                        </mat-form-field>
                        <div *ngIf="community?.password_help_text_rendered && this.community?.register_password_help_text_below_input"
                             [innerHTML]="community?.password_help_text_rendered"
                             class="muted ck-editorControl">
                        </div>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="w-100" color="primary">
                            <mat-label>Confirm password</mat-label>
                            <input #confirmPassword formControlName="confirmPassword"
                                   matInput type="password">
                            <mat-error (click)="confirmPassword.focus()"
                                       *ngIf="signUpForm.controls['confirmPassword'].hasError('required')">
                                This field is required
                            </mat-error>
                            <mat-hint (click)="confirmPassword.focus()"
                                      *ngIf="confirmPassword.value && password.value && password.value != confirmPassword.value"
                                      class="errorMsg">
                                Fields must match
                            </mat-hint>
                        </mat-form-field>
                    </div>
                    <div>
                        <p>{{ community?.profile_picture_title_text ? community?.profile_picture_title_text : 'Profile picture' }}</p>
                        <div class="text-center">
                            <div *ngIf="showCropper" style="width: 250px;margin:auto">
                                <image-cropper
                                        (imageCropped)="imageCropped($event)"
                                        [aspectRatio]="1"
                                        [imageChangedEvent]="imageChangedEvent"
                                        [maintainAspectRatio]="true"
                                        [resizeToWidth]="250"
                                        [roundCropper]="true"
                                        format="png"
                                ></image-cropper>
                            </div>

                            <div (click)="fileInput.click()"
                                 *ngIf="!image"
                                 [style.background-color]="community?.upload_profile_picture_background_color_hex"
                                 [style.color]="this.themeService.getReadableColor(community?.upload_profile_picture_background_color_hex)"
                                 aria-label="Update Profile Picture"
                                 class="initial" matTooltip="Update profile picture"
                                 role="button">
                                <span>{{ community?.profile_picture_inner_text ? community?.profile_picture_inner_text : 'Select Photo' }}</span>
                            </div>
                            <img (click)="fileInput.click()" *ngIf="image" [src]="image" alt=""
                                 aria-label="Update Profile Picture"
                                 class="pp" matTooltip="Update profile picture">
                            <input #fileInput (change)="onFileInput($event)" [multiple]="false"
                                   accept=".jpg, .jpeg, .png, .bmp, .svg, .webp" class="d-none"
                                   type="file"/>
                        </div>

                        <div *ngIf="community?.profile_picture_help_text_rendered"
                             [innerHTML]="community?.profile_picture_help_text_rendered">
                        </div>
                        <div *ngIf="!community?.profile_picture_help_text_rendered">
                            <p>Click to update profile picture</p>
                        </div>
                        <div *ngIf="community?.profile_picture_guidance_text_rendered"
                             [innerHTML]="community?.profile_picture_guidance_text_rendered"
                             class="profileHelp">
                        </div>
                        <div *ngIf="!community?.profile_picture_guidance_text_rendered" class="profileHelp">
                            <small>Max file size: {{ this.maxFileSize }}MB</small>
                            <small>Minimum size: 100 x 100</small>
                            <small>Allowed formats: JPG, JPEG, PNG, BMP, SVG, WEBP</small>
                            <small>Please note your profile picture will be visible to other community
                                members.</small>
                        </div>
                    </div>
                    <div class="flex-auto">
                        <mat-form-field appearance="outline" class="w-100 h-100 fullHeightChildren"
                                        color="accent">
                                <textarea #textarea
                                          [placeholder]="community?.bio_placeholder_text? community?.bio_placeholder_text : 'Bio'"
                                          formControlName="bio"
                                          matInput maxlength="400"
                                          name="message"
                                          rows="1"></textarea>
                        </mat-form-field>
                    </div>

                    <div class="flex-space-between">
                        <div [innerHTML]="community?.terms_help_text_rendered? community?.terms_help_text_rendered: '<p>By creating an account on the ' + companyName +' community, you are giving consent to receiving transactional emails from the Community. The receipt of these emails is important to help you keep up to date on the Community and its content. For more information please refer to our Terms and Conditions and Privacy Policy below.</p>'"
                             class="muted ck-editorControl">
                        </div>
                        <mat-checkbox class="mb-3 w-100" color="accent" formControlName="termsConsent">
                            <small>I have read and understand the
                                <a [routerLink]="['/terms-and-conditions']" target="_blank">Terms and conditions</a>
                                regarding the sign up.</small>
                        </mat-checkbox>
                    </div>
                    <div class="flex-space-between">
                        <div [innerHTML]="community?.email_alerts_text_rendered? community?.email_alerts_text_rendered: '<p>If you do not wish to receive emails alerts from the Community please do not join the ' +  companyName + ' community </p>'"
                             class="muted ck-editorControl">
                        </div>

                        <mat-checkbox class="mb-3 w-100" color="accent" formControlName="privacyConsent">
                            <small>I have read and understand the
                                <a [routerLink]="['/privacy-policy']" target="_blank">Privacy Policy</a>
                                regarding the sign up.</small>
                        </mat-checkbox>
                    </div>
                </div>
            </form>
            <div class="w-100 text-center">
                <button (click)="create()"
                        [disabled]="loading || signUpForm.invalid || !this.signUpForm.value?.termsConsent|| !this.signUpForm.value?.privacyConsent|| email.value !== confirmEmail.value || password.value != confirmPassword.value"
                        class="mx-auto"
                        color="accent" mat-flat-button>
                    Submit
                    <mat-icon *ngIf="loading">
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="login">
            <div *ngIf="community?.already_have_an_account_text_rendered"
                 [innerHTML]="community?.already_have_an_account_text_rendered"></div>

            <form [formGroup]="loginForm" class="mt-10">

                <div *ngIf="community?.subtext_for_email_on_already_have_an_account"
                     [innerHTML]="community?.subtext_for_email_on_already_have_an_account"
                     class="muted ck-editorControl mb-5">
                </div>
                <mat-form-field appearance="outline" class="w-100" color="accent">
                    <mat-label>Email address</mat-label>
                    <input appAutofill formControlName="email" matInput type="email"/>
                    <mat-error *ngIf="loginForm.controls['email'].hasError('required')">
                        This field is required
                    </mat-error>
                    <mat-error *ngIf="loginForm.controls['email'].hasError('email')">
                        Please enter a valid email address
                    </mat-error>
                </mat-form-field>
                <div *ngIf="community?.subtext_for_password_on_already_have_an_account"
                     [innerHTML]="community?.subtext_for_password_on_already_have_an_account"
                     class="muted ck-editorControl mb-5">
                </div>
                <mat-form-field appearance="outline" class="w-100" color="accent">
                    <mat-label>Password</mat-label>
                    <input [type]="passwordType" appAutofill formControlName="password" matInput/>
                    <button (click)="showPassword()"
                            [matTooltip]="passwordType == 'password' ? 'Show password' : 'Hide password'"
                            class="h-fit-content p0" mat-icon-button
                            matSuffix
                            type="button">
                        <mat-icon *ngIf="passwordType == 'password'" color="accent">remove_red_eye
                        </mat-icon>
                        <mat-icon *ngIf="passwordType == 'text'" color="accent">highlight_off</mat-icon>
                    </button>
                    <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>
            </form>
            <button (click)="login = false" mat-button>
                Back to registration
            </button>
            <div class="w-100 text-center">
                <button (click)="existingUserLogin()"
                        [disabled]="loginForm.invalid || loading"
                        color="accent" mat-flat-button>
                    Login
                    <mat-icon *ngIf="loading">
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                </button>
            </div>
        </ng-container>
    </mat-step>
</mat-stepper>
